import { WEBCODE_NORESULT } from "./const";

function action(noResultTerm) {
  return {
    type: WEBCODE_NORESULT,
    noResultTerm,
  };
}

export default action;
